module.exports = __webpack_public_path__ + "static/media/2-min.a0852afa.jpg";